import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` warns when it runs in a component rendered on the server.
 * The effect itself never executes during SSR either way, so swapping to
 * `useEffect` there is behaviorally identical and silences the warning.
 */
export const useIsomorphicLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
